/* tslint:disable */
/* eslint-disable */
/**
 * CheckFlow
 * CheckFlow
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApplicationUser
 */
export interface ApplicationUser {
    /**
     * 
     * @type {string}
     * @memberof ApplicationUser
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUser
     */
    isAuthenticated?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApplicationUser
     */
    permissions?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUser
     */
    jobTitle?: string | null;
}

/**
 * Check if a given object implements the ApplicationUser interface.
 */
export function instanceOfApplicationUser(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ApplicationUserFromJSON(json: any): ApplicationUser {
    return ApplicationUserFromJSONTyped(json, false);
}

export function ApplicationUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'isAuthenticated': !exists(json, 'isAuthenticated') ? undefined : json['isAuthenticated'],
        'permissions': !exists(json, 'permissions') ? undefined : json['permissions'],
        'jobTitle': !exists(json, 'jobTitle') ? undefined : json['jobTitle'],
    };
}

export function ApplicationUserToJSON(value?: ApplicationUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'isAuthenticated': value.isAuthenticated,
        'permissions': value.permissions,
        'jobTitle': value.jobTitle,
    };
}

